<template>
  <div class="app-grain"></div>
</template>

<script>
export default {
  name: 'AppGrain',
};
</script>

<style lang="scss" scoped>
.app-grain {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  pointer-events: none;

  background-image: url('/img/texture/noise.png');
  opacity: 0.018;
}
</style>
